<template>
  <div class="Box" style="margin:30px 50px 0 70px">
      <div class="Box_left">
          <el-form :model="ruleForm" :rules="rules" ref="RuleForm" label-width="100px" class="demo-ruleForm"
          hide-required-asterisk
          >
            <el-form-item label="充值人VIP号 " prop="vipCode">
              <el-input v-model="ruleForm.vipCode" placeholder="请输入用户的VIP号"
              @input="getVipCode"
              ></el-input>
              <div class="Box_accountMsg">
          <div class="exit msg" v-show="userDate.vipCode!==undefined">
            <div class="exit_left">
              <div class="tag tag1">
                用户名
              </div>
              <div class="tag tag3">
                VIP号
              </div>
              <div class="tag tag4">
                手机号
              </div>
            </div>
            <div class="exit_right" >
              <div class="exit_right_text" style="color: #FFD700;">
                {{userDate.nickname}}
              </div>
              <div class="exit_right_text code">
                {{userDate.vipCode}}
              </div>
              <div class="exit_right_text">
                {{userDate.mobile}}
              </div>
            </div>
            
          </div>
          <div class="nexit msg" v-show="userDate.vipCode==undefined&&getLength()>0">
          暂无数据
          </div>
      </div>
            </el-form-item>
            <el-form-item label="现有余额" >
              <el-input class="money_input" v-model="userDate.balance" disabled></el-input>
              <el-input class="money_input_out" v-model="CAD" disabled></el-input>
            </el-form-item>
            <el-form-item label="调账" prop="amount">
              <el-select v-model="search.adjustType" placeholder="选择调账类型" 
                  @change="balanceChange()" style="width:150px;">
                    <el-option
                      v-for="item in adjustTypeSelect"
                      :key="item.adjustType"
                      :label="item.adjustName"
                      :value="item.adjustType">
                    </el-option>
              </el-select>
              <el-input class="money_Adjust" v-model="ruleForm.amount" :disabled="search.adjustType==null"
              @input="balanceChange" type="number" clearable
              placeholder="请输入要调账的金额"
              ></el-input>
            </el-form-item>
            <div class="form-item">
              调账后账户余额将变为:
              <el-input class="money_change" v-model="changedB" disabled></el-input>
              <el-input class="money_input_out" v-model="CAD" disabled></el-input>
            </div>
            <el-form-item label="操作人">
              <el-input v-model="realName" disabled></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="name">
              <el-input
                type="textarea"
                :autosize="{ minRows: 4}"
                placeholder="可输入备注内容"
                v-model="textarea2">
              </el-input>
            </el-form-item>
          </el-form>
      </div>
      <div style="width:100%;text-align: center;">
        <el-button type="primary" @click="submitBt">
          提 交
        </el-button>
      </div>
  </div>
</template>

<script>
import * as mUtils from '../../utils/mUtils'
import * as charge from '../../api/charge'

export default {
    data(){
        return{
            moneyAdjust:'',
            ruleForm:{
                vipCode:'',
                amount:'',
            },
            changedB:0,
            rules:{
              vipCode:[
                { required: true, message: '请输入充值人VIP号', trigger: 'blur' },
            { min: 6, message: '长度为6个字符', trigger: 'blur' }
              ],
              amount:[
                { required: true, message: '请输入调账金额', trigger: 'blur' },
              ]
            },
            CAD:'CAD',
            search:{
               adjustType:null,
            },
            userDate:{},
            realName:'',
            paidCount:[],
            textarea2:'',
            adjustTypeSelect:[
              {
                adjustType:0,
                adjustName:"上调账户余额",
              }, {
                adjustType:1,
                adjustName:"下调账户余额",
              }
            ]
        }
    },
    computed:{
      
    },
    created(){
      this.getlist()
    },
    methods:{
      init(){
      },
      balanceChange(){
        if(this.search.adjustType==0){
          this.changedB=(this.userDate.balance-0)+(this.ruleForm.amount-0)
        }
          else if(this.search.adjustType==1){
            this.changedB=(this.userDate.balance-0)-(this.ruleForm.amount-0)
          }
      },
      getlist(){
        this.userDate=mUtils.getStore('userinfo')
        this.realName=this.userDate.realName
      },
      getVipCode(){
        this.userDate={}
        let param={
          vipCode:this.ruleForm.vipCode
        }
        if(param.vipCode.length>5){
          charge.getVipCode(param).then(res=>{
          console.log(res);
          this.userDate=res.data.data
        })
        }
      },
      getLength(){
        return this.ruleForm.vipCode.length
      },
      submitBt(){
        let param={
          vipCode:this.userDate.vipCode,
          type:this.search.adjustType,
          amount:this.ruleForm.amount-0,
          remark:this.textarea2
        }
        let b=null
         this.$refs.RuleForm.validate(vali=>{
          b=vali
        })
        if(b){
          // if(this.changedB<0){
          // }else 
          if(this.ruleForm.amount-0<0){
            this.$message.error('输入金额不能为负，请重新输入')
          }
          else{
            charge.adjustBalance(param).then(res=>{
          console.log(res);
          if(res.status!==200)
          return this.$message.error('提交调账信息失败')
          if(res.data.code!==0)
          return this.$message.error(res.data.msg)
          else {
          this.ruleForm.vipCode=''
          this.ruleForm.amount=''
          this.textarea2=''
          this.changedB=''
          this.userDate.balance=''
          this.userDate.vipCode=undefined
          this.$message.success('提交调账信息成功')
          }
          })
          }
        }
      }
    }
}
</script>

<style lang="less" scoped>
.Box{
  position: relative;
}
.el-form-item{
}
.el-input{
    width: 38%;
}
.msg{
  margin-top: 5px;
  border-radius: 8px;
  background-color: rgba(238, 238, 238, 0.705);
  width: 38%;
}
.nexit{
  text-align: center;
}
.exit_left{
  margin-left: 20%;
  display: inline-block;
  div{
    line-height: 35px;
  }
}
.exit_right{
  display: inline-block;
  margin-left: 15%;
  .exit_right_text{
    font-size: 18px;
  }
}
.tag{
  border-radius: 4px;
  text-align: center;
  height: 35px;    
  margin-top: 5px;
  &.tag1{
    background-color: #ecf5ff;
    color: #409eff;
    border: 1px solid #d9ecff;
  }
  &.tag2{
    background-color: #dcf6ce;
    border-color: #e1f3d8;
    color: #67c23a;
  }
  &.tag3{
    background-color: #fdf6ec;
    border-color: #faecd8;
    color: #e6a23c;
  }
  &.tag4{
    background-color: #f1df3b;
    border-color: #faf1a3;
    color: #bdae2c;
  }
}
.code{
   color: #00BFFF;
 }
.money_input{
  width: 18%;
  margin-right: 10px;
}
.money_input_out{
  width: 8%;
}
.money_Adjust{
  width: 22.5%;
}
.form-item{
  margin: 0 0 20px 35px;
  .money_change{
    width: 19.5%;
  }
}
</style>


// WEBPACK FOOTER //
// adjust.vue?645c7196